import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PaymentSummaryReportComponent } from './payment-summary-report.component';

const routes: Routes = [
  {
    path:'**',
    component: PaymentSummaryReportComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PaymentSummaryReportRoutingModule { }
